const APP_ID = '520302855352586'
let API_URL = null

/*
 * If REACT_APP_BACKEND_URL is set than use this value as the backend url.
 * In other cases fall back to the defaults depending on the env.
 *
 * You can set an env variable in '.env.<production|development|test>' file
 * More about that here: https://create-react-app.dev/docs/adding-custom-environment-variables
 */
if (process.env.REACT_APP_BACKEND_URL) {
  API_URL = process.env.REACT_APP_BACKEND_URL
} else if (process.env.NODE_ENV === 'development') {
  // Usually in 'development' env the backend url is 'http://localhost:8080'
  API_URL = 'http://localhost:8081'
} else if (process.env.NODE_ENV === 'production') {
  // In a 'production' env the client app is usually on the same domain name as the backend
  API_URL = window.location.origin + '/api'
} else {
  console.log('********************************************')
  console.log('*                                          *')
  console.log('*                                          *')
  console.log("*     Unknown profile '" + process.env.NODE_ENV + "'!       *")
  console.log('* Please review you project configuration! *')
  console.log('*                                          *')
  console.log('*                                          *')
  console.log('********************************************')
}

function setAPIUrl(value) {
  API_URL = value
}

/*
 * The widget session credential, issued by getStarted.
 *
 * The server also sets it as an HttpOnly, Partitioned cookie; this copy is the fallback for browsers that drop
 * third-party cookies outright (Safari), replayed as the X-Neva-Session header and in the STOMP CONNECT frame.
 *
 * Kept in the iframe's own sessionStorage, never in the parent page's storage: that is readable by every
 * third-party script on the host site. sessionStorage dies with the tab, which is the right lifetime for a chat
 * session, and is per tab, so each tab stays on its own chat.
 */
const SESSION_TOKEN_STORAGE_KEY = 'neva-session-token'

let SESSION_TOKEN = null

function sessionStore() {
  try {
    return window.sessionStorage
  } catch {
    // Storage access can throw outright in a partitioned iframe with storage blocked.
    return null
  }
}

function getSessionToken() {
  if (SESSION_TOKEN) {
    return SESSION_TOKEN
  }
  try {
    SESSION_TOKEN = sessionStore()?.getItem(SESSION_TOKEN_STORAGE_KEY) || null
  } catch {
    SESSION_TOKEN = null
  }
  return SESSION_TOKEN
}

function setSessionToken(value) {
  if (!value) {
    return
  }
  SESSION_TOKEN = value
  try {
    sessionStore()?.setItem(SESSION_TOKEN_STORAGE_KEY, value)
  } catch {
    // Non-fatal: the in-memory copy and the cookie still work for this page.
  }
}

function clearSessionToken() {
  SESSION_TOKEN = null
  try {
    sessionStore()?.removeItem(SESSION_TOKEN_STORAGE_KEY)
  } catch {
    // Nothing to clear.
  }
}

export { APP_ID, API_URL, setAPIUrl, getSessionToken, setSessionToken, clearSessionToken }
